import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';

@Component({
    components: {},
})
export default class SBNextBack extends Mixins(SBComponentVue) {

}
